var menu = $('.c-lightbox'),
    btn = $('.menu-btn'),
    menuLink = $('.menu a');

export var navIsOpen = false;
export function navigationEvents() {
    $('body').on('click', btn, function(event) {
        var target = $(event.target);

        if ( !navIsOpen && target.is(btn) ) {
            toggle();
        }

        if(navIsOpen && !target.closest(menuLink).length && !target.is(btn)) {
            toggle();
        }
    }).on('keyup', function (event) {
        if (event.keyCode == 27 && navIsOpen) {
            toggle();
        }
    });
}
function toggle() {
	navIsOpen = !navIsOpen ? true : false;
	$('body').toggleClass('js-nav-open');
}


// WEBPACK FOOTER //
// ./app/js/components/navigation.js